import script from "./DynamicTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicTable.vue?vue&type=script&setup=true&lang=js"

import "./DynamicTable.vue?vue&type=style&index=0&id=8c1f45ae&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c1f45ae"]])

export default __exports__